<script setup lang="ts">
const { notification, dismiss } = useCandidateWriteFailureNotification();
</script>

<template>
  <Alert
    v-if="notification"
    variant="destructive"
    class="shrink-0 rounded-none border-x-0 border-t-0 px-4 py-3"
  >
    <Icon name="lucide:triangle-alert" />
    <AlertTitle>Unable to save your changes</AlertTitle>
    <AlertDescription class="pr-10">
      {{ notification.message }}
      <a
        v-if="notification.contactEmail"
        :href="notification.mailtoHref"
        class="font-semibold underline underline-offset-2"
      >
        {{ notification.contactEmail }}
      </a>
    </AlertDescription>
    <button
      type="button"
      aria-label="Dismiss save failure message"
      class="absolute right-3 top-2.5 rounded-sm p-1 text-destructive/80 hover:bg-destructive/10 hover:text-destructive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      @click="dismiss"
    >
      <Icon name="lucide:x" class="size-4" />
    </button>
  </Alert>
</template>
